import type { JSX } from 'preact/jsx-runtime';
import { Section11Comparable } from '@ox/visits-ui/components/sections/Section11Comparable';
import { Section1Instructions } from '@ox/visits-ui/components/sections/Section1Instructions';
import { Section2PropertyAccess } from '@ox/visits-ui/components/sections/Section2PropertyAccess';
import { Section3AccessIssues } from '@ox/visits-ui/components/sections/Section3AccessIssues';
import { Section4PropertyCondition } from '@ox/visits-ui/components/sections/Section4PropertyCondition';
import { Section5PhotoUpload } from '@ox/visits-ui/components/sections/Section5PhotoUpload';
import { Section6VideoSubmission } from '@ox/visits-ui/components/sections/Section6VideoSubmission';
import { Section8PropertyDetails } from '@ox/visits-ui/components/sections/Section8PropertyDetails';
import { Section9MarketabilityAssessment } from '@ox/visits-ui/components/sections/Section9MarketabilityAssessment';
import { Section10ComparableGate } from '@ox/visits-ui/components/sections/Section10ComparableGate';
import { Section7Valuation } from '@ox/visits-ui/components/sections/Section7Valuation';
import { Section3Utilities } from '@ox/visits-ui/components/sections/Section3Utilities';
import { Section4Condition } from '@ox/visits-ui/components/sections/Section4Condition';
import { Section4InteriorCondition } from '@ox/visits-ui/components/sections/Section4InteriorCondition';
import { Section4ExteriorCondition } from '@ox/visits-ui/components/sections/Section4ExteriorCondition';
import { Section5QCPhotoUpload } from '@ox/visits-ui/components/sections/Section5QCPhotoUpload';
import { Section3Appliances } from '@ox/visits-ui/components/sections/Section3Appliances';
import { Section2QCPropertyAccess } from '@ox/visits-ui/components/sections/Section2QCPropertyAccess';
import { SectionSparkleClean } from '@ox/visits-ui/components/sections/SectionSparkleClean';

type SectionRenderer = () => JSX.Element;

export const sectionComponents: SectionRenderer[] = [
  () => <div>Loading...</div>,
  () => <Section1Instructions />,
  () => <Section2PropertyAccess />,
  () => <Section3AccessIssues />,
  () => <Section4PropertyCondition />,
  () => <Section5PhotoUpload />,
  () => <Section6VideoSubmission />,
  () => <Section7Valuation />,
  () => <Section8PropertyDetails />,
  () => <Section9MarketabilityAssessment />,
  () => <Section10ComparableGate />,
  () => <Section11Comparable compNumber={1} />,
  () => <Section11Comparable compNumber={2} />,
  () => <Section11Comparable compNumber={3} />,
  () => <Section11Comparable compNumber={4} />,
  () => <Section3Utilities />,
  () => <Section4Condition />,
  () => <Section4InteriorCondition isStandard={true} />,
  () => <Section4ExteriorCondition />,
  () => <Section5QCPhotoUpload />,
  () => <Section3Appliances />,
  () => <Section2QCPropertyAccess />,
  () => <Section4InteriorCondition />,
  () => <Section4ExteriorCondition combined />,
  () => <Section5QCPhotoUpload combined />,
  () => <SectionSparkleClean />,
  () => <Section3Utilities perUtility />,
];

export const INSTRUCTIONS = 1;
export const PROPERTY_ACCESS = 2;
export const ACCESS_ISSUES = 3;
export const PROPERTY_CONDITION = 4;
export const PHOTO_UPLOAD = 5;
export const VIDEO_SUBMISSION = 6;
export const VALUATION = 7;
export const PROPERTY_DETAILS = 8;
export const MARKETABILITY_ASSESSMENT = 9;
export const COMPARABLE_GATE = 10;
export const COMPARABLE_1 = 11;
export const COMPARABLE_2 = 12;
export const COMPARABLE_3 = 13;
export const COMPARABLE_4 = 14;
export const UTILITIES = 15;
export const CONDITION = 16;
export const STANDARD_INTERIOR_CONDITION = 17;
export const EXTERIOR_CONDITION = 18;
export const QC_PHOTO_UPLOAD = 19;
export const APPLIANCES = 20;
export const QC_PROPERTY_ACCESS = 21;
export const LIGHTWEIGHT_INTERIOR_CONDITION = 22;
export const STANDARD_EXTERIOR_CONDITION = 23;
export const COMBINED_QC_PHOTO_UPLOAD = 24;
export const SPARKLE_CLEAN = 25;
export const STANDARD_UTILITIES = 26;
